import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL;

function formatTime(iso) {
  return new Date(iso).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}
function formatDate(iso) {
  return new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export default function Dashboard({ onTimbratura }) {
  const { utente } = useAuth();
  const [timbrature, setTimbrature] = useState([]);
  const [loading, setLoading] = useState(true);
  const isAdmin = utente?.ruolo === 'admin' || utente?.ruolo === 'responsabile';

  useEffect(() => {
    axios.get(`${API}/timbrature?perPage=10`)
      .then(res => setTimbrature(res.data.items || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const mieTimbrature = timbrature.filter(t => t.Dipendente === utente?.id);

  const oggi = mieTimbrature.filter(t =>
    new Date(t.timestamp_server).toDateString() === new Date().toDateString()
  );
  const ultimoIngresso = oggi.find(t => (t.Tipo || t.tipo) === 'ingresso');
  const ultimaUscita = oggi.find(t => (t.Tipo || t.tipo) === 'uscita');
  const inAzienda = ultimoIngresso && !ultimaUscita;

  const now = new Date();
  const ora = now.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
  const giorno = now.toLocaleDateString('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });

  return (
    <div style={{ padding: '24px 16px', paddingBottom: 90 }}>
      <div style={{ marginBottom: 24 }}>
        <p style={{ color: '#64748b', fontSize: 13, margin: '0 0 2px', textTransform: 'capitalize' }}>{giorno}</p>
        <h2 style={{ color: '#f1f5f9', fontSize: 24, fontWeight: 800, margin: 0 }}>Ciao, {utente?.nome} 👋</h2>
      </div>

      <div style={{ background: inAzienda ? 'linear-gradient(135deg, #064e3b, #065f46)' : 'linear-gradient(135deg, #1e293b, #0f172a)', border: `1px solid ${inAzienda ? '#10b981' : '#334155'}`, borderRadius: 20, padding: 20, marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <span style={{ fontSize: 11, fontWeight: 700, color: inAzienda ? '#10b981' : '#94a3b8', letterSpacing: '0.1em' }}>
              {inAzienda ? '● IN AZIENDA' : '○ FUORI AZIENDA'}
            </span>
            <div style={{ color: '#f1f5f9', fontSize: 36, fontWeight: 800, lineHeight: 1.1, marginTop: 6 }}>{ora}</div>
          </div>
          <button onClick={onTimbratura}
            style={{ background: inAzienda ? '#10b981' : '#f59e0b', border: 'none', borderRadius: 14, padding: '10px 16px', color: '#0f172a', fontWeight: 800, fontSize: 13, cursor: 'pointer' }}>
            {inAzienda ? 'Timbra Uscita' : 'Timbra Ingresso'}
          </button>
        </div>
        {ultimoIngresso && (
          <p style={{ color: '#94a3b8', fontSize: 12, margin: '12px 0 0' }}>
            Ingresso: <strong style={{ color: '#f1f5f9' }}>{formatTime(ultimoIngresso.timestamp_server)}</strong>
            {ultimaUscita && <> · Uscita: <strong style={{ color: '#f1f5f9' }}>{formatTime(ultimaUscita.timestamp_server)}</strong></>}
          </p>
        )}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
        {[
          { label: 'Ruolo', value: utente?.ruolo || '—' },
          { label: 'Sede', value: utente?.sede || '—' },
          { label: 'Reparto', value: utente?.reparto || '—' },
          { label: 'Email', value: utente?.email || '—' }
        ].map(({ label, value }) => (
          <div key={label} style={{ background: '#1e293b', borderRadius: 14, padding: 14, border: '1px solid #334155' }}>
            <p style={{ color: '#475569', fontSize: 11, fontWeight: 600, margin: '0 0 4px', letterSpacing: '0.08em' }}>{label.toUpperCase()}</p>
            <p style={{ color: '#f1f5f9', fontSize: 12, fontWeight: 600, margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</p>
          </div>
        ))}
      </div>

      <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', marginBottom: 10 }}>
        {isAdmin ? 'ULTIME TIMBRATURE AZIENDA' : 'ULTIME TIMBRATURE'}
      </h3>

      {loading ? (
        <p style={{ color: '#475569', fontSize: 14, textAlign: 'center', padding: 20 }}>Caricamento...</p>
      ) : timbrature.length === 0 ? (
        <p style={{ color: '#475569', fontSize: 14, textAlign: 'center', padding: 20 }}>Nessuna timbratura registrata</p>
      ) : timbrature.map(t => {
        const tipo = t.Tipo || t.tipo;
        const nomeDip = t.expand?.Dipendente
          ? `${t.expand.Dipendente.Nome || ''} ${t.expand.Dipendente.Cognome || ''}`.trim()
          : null;
        const nomeReparto = t.expand?.Reparto?.Nome || '';
        const nomeSede = t.expand?.Sede?.Nome || '';

        return (
          <div key={t.id} style={{ background: '#1e293b', borderRadius: 12, padding: '12px 14px', marginBottom: 8, border: '1px solid #334155', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 8, background: tipo === 'ingresso' ? '#10b98118' : '#ef444418', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, border: `1px solid ${tipo === 'ingresso' ? '#10b98144' : '#ef444444'}`, flexShrink: 0 }}>
                <span style={{ color: tipo === 'ingresso' ? '#10b981' : '#ef4444' }}>{tipo === 'ingresso' ? '→' : '←'}</span>
              </div>
              <div>
                <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 600, margin: 0, textTransform: 'capitalize' }}>{tipo}</p>
                {isAdmin && nomeDip && (
                  <p style={{ color: '#f59e0b', fontSize: 12, fontWeight: 600, margin: '2px 0 0' }}>{nomeDip}</p>
                )}
                {(nomeReparto || nomeSede) && (
                  <p style={{ color: '#475569', fontSize: 11, margin: '2px 0 0' }}>
                    {nomeReparto}{nomeReparto && nomeSede ? ' · ' : ''}{nomeSede}
                  </p>
                )}
              </div>
            </div>
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <p style={{ color: '#f1f5f9', fontSize: 14, fontWeight: 700, margin: 0 }}>{formatTime(t.timestamp_server)}</p>
              <p style={{ color: '#475569', fontSize: 11, margin: 0 }}>{formatDate(t.timestamp_server)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
